module.exports = [{
      plugin: require('../../gatsby-theme/node_modules/gatsby-plugin-theme-ui/gatsby-browser.js'),
      options: {"plugins":[],"injectColorFlashScript":false},
    },{
      plugin: require('../../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-N959NPS","includeInDevelopment":false,"defaultDataLayer":null,"routeChangeEventName":"gatsby-route-change","enableWebVitalsTracking":false,"selfHostedOrigin":"https://www.googletagmanager.com","selfHostedPath":"gtm.js"},
    },{
      plugin: require('../../node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/opt/build/repo/blog/src/layouts/PageLayout.tsx"},
    },{
      plugin: require('../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"MANSCAPED","short_name":"MANSCAPED","start_url":"/","background_color":"#000000","theme_color":"#B98141","display":"browser","lang":"en","icon":"/opt/build/repo/blog/src/assets/favicon.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"43bd81bd020443c3608c3090f494b88d"},
    },{
      plugin: require('../../node_modules/gatsby-plugin-rudderstack/gatsby-browser.js'),
      options: {"plugins":[],"prodKey":"2G36tUgCeyGhl5G5MPYveivgrL0","loadType":"async","sdkURL":"https://www.manscaped.com/rud-js-assets/v3","dataPlaneUrl":"https://www.manscaped.com/rud-dataplane","loadOptions":{"configUrl":"https://www.manscaped.com/rud-api"}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
